import React from 'react';

// Sparkline de la bitácora del cliente (14 días). SVG inline a propósito: montar Recharts para un
// gráfico de 100x26px que se dibuja una vez por fila es desproporcionado.
const W = 92;
const H = 26;
const PAD = 2;

export function activityTotal(values) {
    return (values || []).reduce((acc, v) => acc + (Number(v) || 0), 0);
}

// Tendencia: segunda mitad del período contra la primera.
export function activityTrend(values) {
    const series = values || [];
    if (!series.length) return 'flat';
    const half = Math.floor(series.length / 2);
    let first = 0;
    let second = 0;
    for (let i = 0; i < half; i++) first += Number(series[i]) || 0;
    for (let j = half; j < series.length; j++) second += Number(series[j]) || 0;
    if (second > first * 1.15) return 'up';
    if (second < first * 0.85) return 'down';
    return 'flat';
}

// Línea suavizada (Catmull-Rom convertida a Bézier cúbica), como en el mockup.
function smoothPath(points) {
    let d = `M${points[0][0].toFixed(1)},${points[0][1].toFixed(1)}`;
    for (let i = 0; i < points.length - 1; i++) {
        const p0 = points[i === 0 ? 0 : i - 1];
        const p1 = points[i];
        const p2 = points[i + 1];
        const p3 = points[i + 2 < points.length ? i + 2 : points.length - 1];
        const c1x = p1[0] + (p2[0] - p0[0]) / 6;
        const c1y = p1[1] + (p2[1] - p0[1]) / 6;
        const c2x = p2[0] - (p3[0] - p1[0]) / 6;
        const c2y = p2[1] - (p3[1] - p1[1]) / 6;
        d += ` C${c1x.toFixed(1)},${c1y.toFixed(1)} ${c2x.toFixed(1)},${c2y.toFixed(1)} ${p2[0].toFixed(1)},${p2[1].toFixed(1)}`;
    }
    return d;
}

export function Sparkline({values}) {
    const series = (values || []).map(v => Number(v) || 0);
    if (series.length < 2) return null;

    const max = Math.max(...series, 1);
    const innerW = W - (PAD * 2);
    const innerH = H - (PAD * 2);
    const points = series.map((v, i) => [
        PAD + ((i / (series.length - 1)) * innerW),
        PAD + innerH - ((v / max) * innerH),
    ]);

    const line = smoothPath(points);
    const last = points[points.length - 1];
    const area = `${line} L${last[0].toFixed(1)},${H - PAD} L${points[0][0].toFixed(1)},${H - PAD} Z`;

    return (
        <svg className="cv2-spark" viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" aria-hidden="true" focusable="false">
            <path className="cv2-spark__area" d={area}/>
            <path className="cv2-spark__line" d={line}/>
            <circle className="cv2-spark__last" cx={last[0].toFixed(1)} cy={last[1].toFixed(1)} r="1.9"/>
        </svg>
    );
}

export default Sparkline;
